import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MoviesService } from '../services/movies.service';
import { CustomDataService } from '../services/custom-data.service';


@Component({
  selector: 'latset-tailer',
  templateUrl: './latset-tailerr.component.html',
  styleUrls: ['./latset-tailerr.component.css']
})
export class LatsetTailerrComponent implements OnInit {

  moviesTailer :any[];
  getMovies : any[] ;  
  @Output() tryOutput = new EventEmitter() ; 
  constructor(private movieData:MoviesService, private custom:CustomDataService) 
  {

    this.getMovies = this.movieData.movies ; 
    this.moviesTailer = this.getMovies ;
    
    
   
   }


  ngOnInit() {
  }
  displayTrailler(url:string)
  {
    console.log(url)
    this.custom.setVideoSrc(url) ; 
    this.custom.setVideoDisplay(true) ; 
    console.log(this.custom.videoSrc) ;  
    this.tryOutput.emit() ; 

  }

}
